<template>
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>
        <div class="grid--container">
            <div class="grid--row">
                <div class="grid--col sty-section--shadow-wrapper"
                        v-for="(_, key) in bridgeData"
                        :key="key">
                    <div class="sty-section--shadow"/>
                    <sty-header>
                        <h4 class="u-reset u-reset__sty sty-section--domain-title">
                            {{ key }}
                        </h4>
                    </sty-header>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        components: {
            StyHeader,
        },
        mixins: [bemMixin('sty-section')],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
            bridgeData: {
                type: Object,
                required: true,
            },
        },
    };
</script>
